<script setup lang="ts">
import PredictiveSearch from '@/components/PredictiveSearch.vue'
import {
  loadPredictiveSearchResults,
  type PredictiveSearchResults,
} from '@/services/storefront'
import { ref, watch } from 'vue'

const isShowing = ref(false)
const headerSearchToggle = document.querySelector('.Header__SearchToggle')
const mainSearchToggle = document.querySelector(
  '.MainSearch__Bar input[type=search]',
)

const results = ref<PredictiveSearchResults['data']['predictiveSearch'] | null>(
  null,
)

watch(isShowing, (newValue, oldValue) => {
  // clear query when closing
  if (!newValue && oldValue) {
    query.value = ''
  }
})

if (headerSearchToggle) {
  headerSearchToggle.addEventListener(
    'click',
    () => (isShowing.value = !isShowing.value),
  )
}

if (mainSearchToggle) {
  mainSearchToggle.addEventListener(
    'focus',
    () => (isShowing.value = !isShowing.value),
  )
}

const query = ref<string>(
  new URLSearchParams(window.location.search).get('q') || '',
)
watch(query, async () => {
  if (query.value.length > 2) {
    const res = await loadPredictiveSearchResults(query.value)
    results.value = res.data.predictiveSearch
  } else {
    results.value = null
  }
})

const onlineStoreUrlWithTrackingParams = (entity: {
  onlineStoreUrl: string
  trackingParameters: string | null
}) => {
  const url = new URL(entity.onlineStoreUrl)
  if (entity.trackingParameters) {
    new URLSearchParams(entity.trackingParameters).forEach((value, key) => {
      url.searchParams.append(key, value)
    })
  }
  return url.toString()
}

const clickItemUnderCursor = (cursorIndex: number) => {
  if (results.value && cursorIndex > -1) {
    if (cursorIndex < results.value.queries.length) {
      query.value = results.value.queries[cursorIndex].text
    } else if (
      cursorIndex <
      results.value.queries.length + results.value.products.length
    ) {
      window.location.href = onlineStoreUrlWithTrackingParams(
        results.value.products[cursorIndex - results.value.queries.length],
      )
    } else if (
      cursorIndex <
      results.value.queries.length +
        results.value.products.length +
        results.value.pages.length
    ) {
      window.location.href = onlineStoreUrlWithTrackingParams(
        results.value.pages[
          cursorIndex -
            (results.value.queries.length + results.value.products.length)
        ],
      )
    } else if (
      cursorIndex <
      results.value.queries.length +
        results.value.products.length +
        results.value.pages.length +
        results.value.articles.length
    ) {
      window.location.href = onlineStoreUrlWithTrackingParams(
        results.value.articles[
          cursorIndex -
            (results.value.queries.length +
              results.value.products.length +
              results.value.pages.length)
        ],
      )
    } else {
      window.location.href = `/search?q=${encodeURIComponent(query.value)}`
    }
  } else {
    window.location.href = `/search?q=${encodeURIComponent(query.value)}`
  }
}
</script>

<template>
  <PredictiveSearch
    :is-showing="isShowing"
    :results="results"
    :query="query"
    @close="isShowing = false"
    @change="query = $event"
    @select="clickItemUnderCursor"
  ></PredictiveSearch>
</template>
